/** Contactos PM: representante legal + socios (RFC, CURP, nombre, WhatsApp). */

export const SOCIO_COUNT = 3;

export function emptyContactoPersona() {
  return { rfc: "", nombre: "", curp: "", whatsapp: "", acepta_whatsapp: false };
}

export function emptyContactosPm() {
  return {
    representante_legal: emptyContactoPersona(),
    socios: Array.from({ length: SOCIO_COUNT }, () => emptyContactoPersona()),
    titular_es_representante: false,
  };
}

function normPerson(raw) {
  const p = raw && typeof raw === "object" ? raw : {};
  return {
    rfc: String(p.rfc || "")
      .trim()
      .toUpperCase(),
    nombre: String(p.nombre || "").trim(),
    curp: String(p.curp || "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 18),
    whatsapp: String(p.whatsapp || "").trim(),
    acepta_whatsapp: Boolean(p.acepta_whatsapp),
  };
}

export function normalizeContactosPm(raw) {
  const base = emptyContactosPm();
  if (!raw || typeof raw !== "object") return base;
  const sociosIn = Array.isArray(raw.socios) ? raw.socios : [];
  return {
    representante_legal: normPerson(raw.representante_legal),
    socios: Array.from({ length: SOCIO_COUNT }, (_, i) => normPerson(sociosIn[i])),
    titular_es_representante: Boolean(raw.titular_es_representante),
  };
}

/** Al cargar cliente desde API: migrar legacy o usar contactos_pm. */
export function contactosPmFromClient(client) {
  if (client?.contactos_pm && typeof client.contactos_pm === "object") {
    return normalizeContactosPm(client.contactos_pm);
  }
  const out = emptyContactosPm();
  if (client?.representante_legal) {
    out.representante_legal.nombre = String(client.representante_legal).trim();
  }
  const legacy = [
    client?.contacto_contable,
    client?.contacto_nomina,
    client?.contacto_administrativo,
  ];
  legacy.forEach((nombre, i) => {
    if (nombre && out.socios[i]) out.socios[i].nombre = String(nombre).trim();
  });
  return out;
}

export function setContactosPmOnForm(form, contactosPm) {
  return { ...form, contactos_pm: normalizeContactosPm(contactosPm) };
}

export function updateContactosPm(form, patch) {
  return setContactosPmOnForm(form, { ...form.contactos_pm, ...patch });
}

export function updatePersonInContactos(form, section, index, field, value) {
  const cm = normalizeContactosPm(form.contactos_pm || emptyContactosPm());
  if (section === "representante_legal") {
    cm.representante_legal = { ...cm.representante_legal, [field]: value };
  } else if (section === "socios" && index >= 0 && index < SOCIO_COUNT) {
    cm.socios[index] = { ...cm.socios[index], [field]: value };
  }
  return setContactosPmOnForm(form, cm);
}

/** Aplica campos del parseo CSF al contacto (PF: RFC, nombre, CURP). No toca WhatsApp. */
export function applyCsfFieldsToPerson(person, fields = {}) {
  const base = normPerson(person);
  const rfc = String(fields.rfc || "")
    .trim()
    .toUpperCase();
  const nombre = String(fields.razon_social || fields.nombre || "").trim();
  const curp = String(fields.curp || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, 18);
  return {
    ...base,
    rfc: rfc || base.rfc,
    nombre: nombre || base.nombre,
    curp: curp || base.curp,
  };
}

/**
 * Validación compacta para socios: ¿la CSF sugiere régimen/obligación de socios-accionistas?
 * No aplica al representante legal (role !== "socio").
 */
export function assessSocioAccionistaFromCsf(fields = {}) {
  const regimen = String(fields.regimen_fiscal || "");
  const obligaciones = Array.isArray(fields.obligaciones_detectadas)
    ? fields.obligaciones_detectadas.map((o) => String(o || "").trim()).filter(Boolean)
    : [];
  const blob = [regimen, ...obligaciones].join(" ").toLowerCase();
  const matched = Boolean(
    /\b611\b/.test(blob)
      || /socio\s+o\s+accionista|socios?\s+y\s+accionistas|ingresos\s+por\s+dividend/.test(blob)
      || /dividendos?\s*\(socios/.test(blob),
  );
  return {
    matched,
    regimen: regimen.trim(),
    obligaciones: obligaciones.slice(0, 12),
    message: matched
      ? "La constancia sugiere régimen/obligación de socios o accionistas (p. ej. 611)."
      : "No se detectó en la constancia una obligación clara de Socio o Accionista (puede ser válido).",
  };
}
